const React = require('react');

const Container = require('../common/Container.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region V1

function StatementV1(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.Statement)) {
        return null;
    }
    let blockProps = {};
    let content = data.Statement;
    let borderStyleBottom, borderStyleTop, style;
    if (props.config) {
        if (props.config.Config && props.config.Config.Block) {
            blockProps = props.config.Config.Block;
            style = Utilities.Config.getStyle(data, blockProps, '');

            if (!Utilities.isNullOrWhitespace(blockProps.borderTop)) {
                borderStyleTop = { borderTop: blockProps.borderTop };
            }
            if (!Utilities.isNullOrWhitespace(blockProps.borderTopSpacing)) {
                borderStyleTop = borderStyleTop || {};
                borderStyleTop.paddingTop = blockProps.borderTopSpacing;
            }
            if (!Utilities.isNullOrWhitespace(blockProps.borderBottom)) {
                borderStyleBottom = { borderBottom: blockProps.borderBottom };
            }
            if (!Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing)) {
                borderStyleBottom = borderStyleBottom || {};
                borderStyleBottom.paddingTop = blockProps.borderBottomSpacing;
            }
        } else if (props.config.config && props.config.config.Block) {
            blockProps = props.config.config.Block;
            content = props.content;
            style = Utilities.Config.getStyleV2(blockProps, undefined, (propName, propValue, _style) => {
                if (propName.indexOf('Border') < 0) {
                    return;
                }
                if (propValue && propValue.value && propValue.unit) {
                    _style[propName.replace('Border', '')] = `${propValue.value}${propValue.unit}`;
                }
                return true;
            });
            // if (blockProps.borderTopWidth && !Utilities.isNullOrWhitespace(blockProps.borderTopWidth.value)) {
            //     borderStyleTop = { borderTopColor: blockProps.borderTopColor, borderTopStyle: blockProps.borderTopStyle, borderTopWidth: `${blockProps.borderTopWidth.value}${blockProps.borderTopWidth.unit}` };
            // }
            // if (blockProps.borderTopSpacing && !Utilities.isNullOrWhitespace(blockProps.borderTopSpacing.value)) {
            //     borderStyleTop = borderStyleTop || {};
            //     borderStyleTop.paddingBottom = `${blockProps.borderTopSpacing.value}${blockProps.borderTopSpacing.unit}`;
            // }
            // if (blockProps.borderBottomWidth && !Utilities.isNullOrWhitespace(blockProps.borderBottomWidth.value)) {
            //     borderStyleBottom = { borderBottomColor: blockProps.borderBottomColor, borderBottomStyle: blockProps.borderBottomStyle, borderBottomWidth: `${blockProps.borderBottomWidth.value}${blockProps.borderBottomWidth.unit}` };
            // }
            // if (blockProps.borderBottomSpacing && !Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing.value)) {
            //     borderStyleBottom = borderStyleBottom || {};
            //     borderStyleBottom.paddingTop = `${blockProps.borderBottomSpacing.value}${blockProps.borderBottomSpacing.unit}`;
            // }
        }
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {
                borderStyleTop != undefined &&
                <tr><td style={borderStyleTop} /></tr>
            }
            <tr>
                <td>
                    <div dangerouslySetInnerHTML={{ __html: content }} style={style} />
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                Utilities.isNullOrWhitespace(data.Statement) &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
            {
                borderStyleBottom != undefined &&
                <tr><td style={borderStyleBottom} /></tr>
            }
        </Container>
    );
}

const TypeConfigV1 = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    TypeConfig.options.firstPageOnly(),
                    ...TypeConfig.options.border(),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Statement Properties', id: 'statementProps', type: 'header' },
                    ...TypeConfig.options.text({}, {}, {})
                ]
            };
        },
        style: function () { return TypeConfig.panel.layoutStyle({}, {}); }
    }
};

// #endregion V1

// #region V2

const StatementV2 = Token.withContentTokenParsing(
    StatementV1,
    {},
    (props, keyword) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.Statement:
                if (!Utilities.isNullOrWhitespace(data.Statement)) {
                    replaceString = Token.cleanTokenValueForReplacement(data.Statement);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString
    }
);
const TokensStatement = () => [{ display: 'Statement', token: Token.Statement }];
const TypeConfigV2 = {
    panel: {
        block: (firstPageOnly) => {
            const group = 'block';
            let options = [];
            if (firstPageOnly) {
                options = [];
            }
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Only Show On First Page',
                        group,
                        fullWidth: true,
                        name: 'renderOnlyFirst',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Design authenticity statement here',
                        label: 'Statement Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: Utilities.wrapTextForEditor({ text: `{${Token.Statement}}`, token: Token.Statement })
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Border Properties',
                        group,
                        id: 'borderProps',
                        type: 'header'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.dropdown.measurement(),
                        type: 'border'
                    },
                    {
                        disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                        display: 'Border Spacing',
                        group,
                        name: 'paddingMarginBorder',
                        nameSuffix: 'Border',
                        options: TypeConfig.dropdown.measurement(),
                        type: 'paddingMargin'
                    }
                ]
            };
        },
        style: () => TypeConfig.panel.layoutStyleV2('style', 'Layout', {}, undefined)
    }
};

// #endregion V2

module.exports = {
    V1: {
        Component: StatementV1,
        TypeConfig: TypeConfigV1
    },
    V2: {
        Component: StatementV2,
        Tokens: TokensStatement,
        TypeConfig: TypeConfigV2
    }
};